'use strict';

// pc导航控制
// $('header #nav .menu').mouseenter(function () {
//     $(this).children('.sub-menu').addClass('active');
// })
// $('header #nav .menu').mouseleave(function () {
//     $(this).children('.sub-menu').removeClass('active');
// })

// 手机导航控制
$('header .menu-btn').click(function () {
    $('#header .nav').toggleClass('open');
});
$('#nav i').click(function () {
    $(this).siblings('.sub-menu').toggleClass('active');
});